const contactPage = $('#contactForm').length;

export function contactFunc() {
  if (contactPage) {
      $(".contactFaqContainerAcc").hide();
      $(".contactFaqVeiwAllBtn").click(function() {
        $(".contactFaqContainerAcc").slideToggle(300);
        $(this).toggleClass("open");
        if($(this).hasClass("open")){
          $(this).html("<button>CERRAR</button>");
        } else {
          $(this).html("<button>VER TODO</button>");
        }
        return false;
      });
    
    
    const typeSelect = $("[name='type']");
    let selectIndex = '';

    const formField = $('#formField');

    // お問い合わせ種別
    const selectControl = function () {
      for (var val = "", i = typeSelect.length; i--;) {
        if (typeSelect[i].checked) {
          var val = typeSelect[i].value;
          break;
        }
      }
      selectIndex = val;
      if (selectIndex != '') {
        if (selectIndex == 'job') {
          $('#job').addClass('isShow');
        } else {
          formField.addClass('isShow');
          if (selectIndex == 'business') {
            $('#business').addClass('isShow');
          } else {
            $('#basic').addClass('isShow');
            if (selectIndex == 'online') {
              $('.online').addClass('isShow');
            } else if (selectIndex == 'product') {
              $('.product').addClass('isShow');
            } else if (selectIndex == 'inferior') {
              $('.inferior').addClass('isShow');
            } else if (selectIndex == 'interview') {
              $('.interview').addClass('isShow');
            } else if (selectIndex == 'other') {
              $('.other').addClass('isShow');
            }
          }
        }
      }
    }

    // 必須項目名
    const companyName = $("[name='companyName']");
    const mediaName = $("[name='mediaName']");
    const contactName = $("[name='contactName']");
    const myName = $("[name='myName']");
    const email = $("[name='email']");
    const emailCheck = $("[name='emailCheck']");
    const telNumber = $("[name='telNumber']");
    const subject = $("[name='subject']");
    const product = $("[name='product']");
    const content = $("[name='content']");
    const businessCompanyName = $("[name='businessCompanyName']");
    const yearMonth = $("[name='yearMonth']");
    const capital = $("[name='capital']");
    const employeeNum = $("[name='employeeNum']");
    const tradingCompany = $("[name='tradingCompany']");
    const annualSales = $("[name='annualSales']");
    const businessContactName = $("[name='businessContactName']");
    const postalCode = $("[name='postalCode']");
    const companyAddress = $("[name='companyAddress']");
    const companyTelNumber = $("[name='companyTelNumber']");
    const companyEmail = $("[name='companyEmail']");
    const companyEmailCheck = $("[name='companyEmailCheck']");
    const tradingProducts = $("[name='tradingProducts']");
    const tradingPlans = $("[name='tradingPlans']");
    const tradingCountry = $("[name='tradingCountry']");
    const salesForms = $("[name='salesForms']");
    const monthlySales = $("[name='monthlySales']");
    const otherRequest = $("[name='otherRequest']");
    /***US版用項目***/
    const inquiry = $("[name='inquiry']");
    const age = $("[name='age']");
    const country = $("[name='country']");
    /**************/
    const agreeCheck = $("[name='agreeCheck']");

    // 必須項目定義
    const onlineRequired = [inquiry, myName, age, country, email, emailCheck, telNumber, content, agreeCheck];
    //const onlineRequired = [myName, email, emailCheck, telNumber, content, agreeCheck];
    //const productRequired = [myName, email, emailCheck, telNumber, product, content, agreeCheck];
    //const inferiorRequired = [myName, email, emailCheck, telNumber, product, content, agreeCheck];
    //const businessRequired = [businessCompanyName, yearMonth, capital, employeeNum, tradingCompany, annualSales, businessContactName, postalCode, companyAddress, companyTelNumber, companyEmail, companyEmailCheck, tradingProducts, tradingPlans, tradingCountry, salesForms, monthlySales, agreeCheck];
    //const interviewRequired = [companyName, mediaName, contactName, email, emailCheck, telNumber, content, agreeCheck];
    //const otherRequired = [myName, email, emailCheck, telNumber, content, agreeCheck];

    // 必須項目設定
    let requiredField = [];
    const requiredFieldSet = function () {
      /*
      switch (selectIndex) {
        case 'online':
          requiredField = onlineRequired;
          break;
        case 'product':
          requiredField = productRequired;
          break;
        case 'inferior':
          requiredField = inferiorRequired;
          break;
        case 'business':
          requiredField = businessRequired;
          break;
        case 'interview':
          requiredField = interviewRequired;
          break;
        case 'other':
          requiredField = otherRequired;
          break;
      }
      */
      requiredField = onlineRequired;
      for (let i = 0; i < requiredField.length; i++) {
        let requiredFieldType = requiredField[i].attr('type');
        if (requiredFieldType == 'radio' || requiredFieldType == 'checkbox') {
          requiredField[i].change(function () {
            fieldCheck(requiredField[i]);
          });
        } else {
          requiredField[i].blur(function () {
            fieldCheck(requiredField[i]);
          });
        }
      }
    }

    // リロード時実行
    //selectControl();
    requiredFieldSet();

    // セレクト選択時実行
    /*
    typeSelect.change(function () {
      formField.removeClass('isShow');
      $('.split').removeClass('isShow');
      //selectIndex = typeSelect.val();
      //selectControl();
      requiredFieldSet();
    });
    */
    

    const agreeCheckTxt = '*Debe aceptar la Política de Privacidad';
    const emailRequiredTxt = '*Error en el formato de la dirección de correo electrónico.';
    const emailDuplication = '*La dirección de correo electrónico y la confirmación no coinciden.';
    const telRequiredTxt = '*Este campo debe contener sólo números';

    let errorTxt = '';
    const fieldCheck = function (checkField, all = false) {
      let checkFieldValue = checkField.val();
      let checkFieldType = checkField.attr('type');
      let checkFieldTag = checkField[0].tagName;
      let checkFieldName = checkField.attr('name');
      let checkFieldLabel = $('[for= ' + checkFieldName + ']');
      let checkFieldLabelTxt = checkFieldLabel.text().replace("*Obligatorio", "");
      if (checkFieldType == 'radio') {
        //errorTxt = checkFieldLabelTxt + 'は選択必須です';
        errorTxt = '*Obligatorio';
        if (!checkField.is(':checked')) {
          checkField.parents('.radioArea').addClass('error').next('.errorTxt').text(errorTxt);
        } else {
          checkField.parents('.radioArea').removeClass('error').next('.errorTxt').text('');
        }
      } else if (checkField == agreeCheck) {
        if (!checkField.is(':checked')) {
          checkField.parents('.checkboxArea').addClass('error').next('.errorTxt').text(agreeCheckTxt);
        } else {
          checkField.parents('.checkboxArea').removeClass('error').next('.errorTxt').text('');
        }
      } else if (checkField.hasClass('select')) {
        //errorTxt = checkFieldLabelTxt + 'は選択必須です';
        errorTxt = '*Obligatorio';
        if (checkFieldValue == '') {
          checkField.addClass('error').parent('.selectBtn').next('.errorTxt').text(errorTxt);
        } else {
          checkField.removeClass('error').parent('.selectBtn').next('.errorTxt').text('');
        }
      } else {
        //errorTxt = checkFieldLabelTxt + 'は入力必須です';
        errorTxt = '*Obligatorio';
        if (checkFieldName == 'content' && selectIndex != 'inferior') {
          //errorTxt = 'お問い合わせ内容は入力必須です';
          errorTxt = '*Obligatorio';
        }
        if (checkFieldValue == '') {
          checkField.addClass('error').next('.errorTxt').text(errorTxt);
        } 
        else if (checkField == myName && checkFieldValue.length >= 51) {
          errorTxt = '*Este campo es obligatorio.';
          checkField.addClass('error').next('.errorTxt').text(errorTxt);
        }
        else if (checkFieldType == 'email' && !checkFieldValue.match(/^([a-zA-Z0-9])+([a-zA-Z0-9\._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9\._-]+)+$/)) {
          checkField.addClass('error').next('.errorTxt').text(emailRequiredTxt);
        } 
        else if (checkField == email && checkFieldValue.length >= 51) {
          errorTxt = '*Este campo es obligatorio.';
          checkField.addClass('error').next('.errorTxt').text(errorTxt);
        }
        else if (checkField == emailCheck && checkFieldValue != email.val()) {
          checkField.addClass('error').next('.errorTxt').text(emailDuplication);
        } 
        else if (checkFieldType == 'email' && checkFieldValue.match('qq.com')) {
          checkField.addClass('error').next('.errorTxt').text(emailRequiredTxt);
        } 
        else if (checkFieldType == 'tel' && !checkFieldValue.match('^[0-9]')) {
          checkField.addClass('error').next('.errorTxt').text(telRequiredTxt);
        } 
        else if (checkField == telNumber && checkFieldValue.length >= 21) {
          errorTxt = '*Este campo es obligatorio.';
          checkField.addClass('error').next('.errorTxt').text(errorTxt);
        }
        else if (checkFieldTag == 'TEXTAREA' && checkFieldValue.length >= 501) {
          errorTxt = '*Este campo es obligatorio.';
          checkField.addClass('error').next('.errorTxt').text(errorTxt);
        } 
        else if (checkField == age && checkFieldValue.length >= 4) {
          errorTxt = '*Este campo es obligatorio.';
          checkField.addClass('error').next('.errorTxt').text(errorTxt);
        } 
        else if (checkField == age && !checkFieldValue.match('^[0-9]')) {
          errorTxt = '*Este campo debe contener sólo números';
          checkField.addClass('error').next('.errorTxt').text(errorTxt);
        }
        else {
          checkField.removeClass('error').next('.errorTxt').text('');
        }
      }
    };

    otherRequest.blur(function () {
      if (otherRequest.val().length >= 501) {
        errorTxt = '*Este campo es obligatorio.';
        otherRequest.addClass('error').next('.errorTxt').text(errorTxt);
      } else {
        otherRequest.removeClass('error').next('.errorTxt').text('');
      }
    });

    let sendBtn = $('#sendBtn');
    // 各項目をサブミット処理でチェック（個人、法人フォーム）
    $('form').submit(function (e) {
      // 初期設定
      let set = 0;
      if (set == 0) {
        set = 1;
      } else {
        return false;
      }

      // 各項目をチェック（個人フォーム用）
      for (let i = 0; i < requiredField.length; i++) {
        fieldCheck(requiredField[i]);
      }

      // エラー箇所があればその場所までスクロール
      let offsetTxt, headerHeight;
      if ($('.errorTxt').text() != '') {
        offsetTxt = $('.error').offset().top;
        headerHeight = $('#header').outerHeight();
        $('html,body').animate({
          scrollTop: offsetTxt - headerHeight
        }, 500);
        return false;
      }

      // エラーがなければ二重送信禁止
      sendBtn.prop('disabled', 'true');
      setTimeout(function () {
        sendBtn.prop('disabled', '');
      }, 1000);
      return true;
    });

    // ラジオボタンチェック時入力欄有効可
    const radioBtn = document.querySelectorAll('.radioBtn');
    const radioField = document.querySelectorAll('.radioField');
    for (let i = 0; i < radioBtn.length; i++) {
      if (radioBtn[i].checked) {
        radioField[i].disabled = false;
      } else {
        radioField[i].disabled = true;
      }
    }
    $("input[type='radio']").on('click', function () {
      for (let i = 0; i < radioBtn.length; i++) {
        if (radioBtn[i].checked) {
          radioField[i].disabled = false;
        } else {
          radioField[i].disabled = true;
          radioField[i].value = '';
        }
      }
    });

    // チェックボックスチェック時入力欄有効可
    const checkBtn = document.querySelectorAll('.checkBtn');
    const checkField = document.querySelectorAll('.checkField');
    for (let i = 0; i < checkBtn.length; i++) {
      if (checkBtn[i].checked) {
        checkField[i].disabled = true;
        checkField[i].value = '';
      } else {
        checkField[i].disabled = false;
      }
    }
    $("input[type='checkbox']").on('click', function () {
      for (let i = 0; i < checkBtn.length; i++) {
        if (checkBtn[i].checked) {
          checkField[i].disabled = true;
          checkField[i].value = '';
        } else {
          checkField[i].disabled = false;
        }
      }
    });
  }
}
